import React, { useEffect, useState } from 'react';
import { Container, Typography, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link } from '@mui/material';
import { useStyles } from '../pages/Gui/gui'
import RefreshIcon from '@mui/icons-material/Refresh';
import dayjs from 'dayjs';
import { Redirect } from 'react-router';
import { useHistory } from 'react-router-dom';
import { render } from '@testing-library/react';
import { useAuth, TokenPayload } from '../contexts/AuthContext';
import utc from 'dayjs/plugin/utc'
import { NextWatchDate, NextWatch } from '../utils/koa-common';
import jwt_decode, { JwtPayload } from "jwt-decode"
import { replace } from 'lodash';

dayjs.extend(utc)


interface Props {
    darkstate?: boolean
}

function NewSessionDialog(props: any){

    const { user, setWatchDate, watchDate, startnewsession, token } = useAuth()
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const history = useHistory()
    const startNewSession = () => {
        try {
            // Make call to refreshToken(), this updates the semids and access
            const decoded: TokenPayload = jwt_decode(token);
            const obs_dt = dayjs.utc()
            startnewsession(obs_dt)
            const obs_dt_str = `${obs_dt.format('YYYY-MM-DD')}`
        }catch (err) {}

        handleClose()
    }

    return (
        <>
            <Button endIcon={<RefreshIcon />} variant="contained" sx={{ marginLeft: '1em' }} size="small" onClick={handleClickOpen}>New Session</Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Start a New Session?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        A new session automatically starts at <strong>Midnight UTC</strong> but if you would like to reset the RTI table for a fresh start, click NEW SESSION
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant='contained'>Cancel</Button>
                    <Button onClick={startNewSession} autoFocus variant='contained'>
                        NEW SESSION
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export function NewSession(props: any) {
    const { user, setWatchDate, watchDate, startnewsession, token } = useAuth()
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const history = useHistory()
    const startNewSession = () => {
        try {
            // Make call to refreshToken(), this updates the semids and access
            const decoded: TokenPayload = jwt_decode(token);
            const obs_dt = dayjs.utc()
            startnewsession(obs_dt)
            const obs_dt_str = `${obs_dt.format('YYYY-MM-DD')}`
        }catch (err) {}

        handleClose()
    }

    return (
        <div>
            <Link href="https://koa.ipac.caltech.edu/cgi-bin/Helpdesk/nph-genTicketForm?projname=KOA" style={{marginLeft: '1em'}} target="_blank" className={props.darkstate ? 'text-darkstate' : 'text-standard'}>KOA Helpdesk</Link>
            <Link href="/UserGuide/odap_help.html" style={{marginLeft: '1em'}} target="_blank" className={props.darkstate ? 'text-darkstate' : 'text-standard'}>User Guide</Link>
        </div>
    );
}

export default function NightStatus(props: any) {
    const history = useHistory()
    // Update to Pull from DB
    const [timenextsession, setTimeNextSession] = useState<number>(0);
    const [msgnextsession, setMsgNextSession] = useState<string>("");

    const current_time = new Date();
    const { loggedIn, user, setWatchDate, watchDate} = useAuth()
    useEffect(() => {
        let output_str = `${NextWatch('hours')} hours or ${NextWatch('minutes')} minutes`;
        setMsgNextSession(output_str)
        setTimeNextSession(NextWatch('minutes'))

        const ticker = setInterval(x => {
            output_str = `${NextWatch('hours')} hours or ${NextWatch('minutes')} minutes`;
            setTimeNextSession(NextWatch('minutes'))
            setMsgNextSession(output_str)
        }, 60000)
        return (function () {
            clearInterval(ticker)
        })
    }, [timenextsession])

    const classes = useStyles();
    return (
        <>
            { loggedIn ?
                <NewSession  props={props.darkState}/>:
                <></>
            }
        </>
    );
};
